import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const salesOrderGetNextDocumentNumberAtom = createMutationAtomFactory(
  'trade.salesOrderGetNextDocumentNumber',
  () => ({
    tradeSalesOrderNextDocumentNumber: true,
  }),
);
